import styled from 'styled-components'

export const ContentAccordion = styled.div`
  .last {
    border: none;
  }
`
